import { Comune } from '../tipologiche/comune';
import { Provincia } from '../tipologiche/provincia';

export class Ubicazione {
  id: string;
  via: string;
  civico: string;
  cap: string;
  localita: Comune;
  provincia: Provincia;
  nazione: string;
}
